import $ from 'jquery';
import './lib/lib';
import './base/base';
import './elements/elements';
import './modules/modules';

import './main.scss';

$(document).ready(() => {
  $('.js-image-carousel--rtl').slick({
    arrows: false,
    dots: true,
    slidesToShow: 1,
    lazyLoad: 'progressive',
    rtl: true,
    touchThreshold: 20,
  });
});



// WEBPACK FOOTER //
// ./styleguide/src/assets/styleguide.js